import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image'
import { AppBar, Toolbar, createStyles } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import MenuIcon from '@material-ui/icons/Menu'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Hidden from '@material-ui/core/Hidden'
import Drawer from '@material-ui/core/Drawer'
import Button from '../../components/Button'
import ButtonSelector from '../../components/ButtonSelector'
import { navigate, Link } from 'gatsby'
import Typography from '@material-ui/core/Typography'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Fade from '@material-ui/core/Fade'
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import Divider from '@material-ui/core/Divider'
import CloseIcon from '@material-ui/icons/Close'
import SearchIcon from '@material-ui/icons/Search'
import Icon from '@material-ui/core/Icon'
import { graphql, useStaticQuery } from 'gatsby'

const useStyles = makeStyles((theme) =>
    createStyles({
        appBar: {
            backgroundColor: theme.palette.background.default,
            boxShadow: '0px 0px',
        },
        mobileDropdown: {
            backgroundColor: theme.palette.background.default,
        },
        fullList: {
            width: 'auto',
        },
        image: {
            width: '200px',
            [theme.breakpoints.down('sm')]: {
                width: '97px',
                height: '40px',
                marginTop: '25px',
            },
        },
        link: {
            height: '100%',
            fontSize: '0.98rem',
            fontWeight: 'bold',
            textDecoration: 'none',
            color: theme.palette.secondary.black,
            '&:hover': {
                backgroundColor: theme.palette.background.default,
                color: theme.palette.secondary.main,
                cursor: 'pointer',
            },
            [theme.breakpoints.down('sm')]: {
                color: theme.palette.text.black,
            },
        },
        active: {
            color: theme.palette.secondary.main,
        },
        listItem: {
            backgroundColor: theme.palette.background.white,
        },
        listItemfff: {
            position: 'absolute',
            width: '87px',
            height: '42px',
            right: '20px',
            top: '16px',
            paddingLeft: '0px',
        },
        listItemText: {
            fontFamily: 'IBM Plex Sans',
            fontStyle: 'normal',
            fontWeight: ' bold',
            fontSize: '14px',
            lineHeight: '18px',
        },
        gridItem: {
            textAlign: 'center',
        },
        buttonPrimary: {
            minWidth: '8.375rem',
            height: '3.625rem',
            borderRadius: '1rem',
            color: theme.palette.text.white,
            fontSize: '1.25rem',
            margin: '10px 0px 0px 0px',
            background:
                'linear-gradient(138.25deg, #FFAF75 7%, #F45F00 95.28%)',
            '&:hover': {
                background:
                    'linear-gradient(138.25deg, rgba(255, 175, 117, 0.5) 7%, rgba(244, 95, 0, 0.5) 95.28%)',
            },
            [theme.breakpoints.down('sm')]: {
                minWidth: '7.438rem',
                margin: '10px 0px 0px -21px',
                height: '2.625rem',
                fontSize: '0.875rem',
            },
        },
        buttonSecondary: {
            width: '100%',
            height: '3.625rem',
            borderRadius: '0.938rem',
            color: theme.palette.text.white,
            fontSize: '1.25rem',
            background:
                'linear-gradient(152.51deg, #14FFD7 -64.25%, #75CCBD 105.81%)',
            '&:hover': {
                background:
                    'linear-gradient(152.51deg, rgba(20, 255, 215, 0.5) -64.25%, rgba(117, 204, 189, 0.5))',
            },
        },
        buttonContainer: {
            textAlign: 'right',
        },
        dropdownText: {
            fontFamily: 'IBM Plex Sans',
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: '14px',
            lineHeight: ' 18px',
            paddingLeft: '16px',
            marginTop: '16px',
        },
    })
)
//Navigation item links go to homepage if you click home while being on another page
const link = (id, name, pathPrefix) =>
    name === 'index' ? '/' : pathPrefix ? `/${pathPrefix}/${name}` : `/${name}`
const applyLink = (name) => (name === 'index' ? '/' : `/${name}`)
//Navigation mobile or tablet
const TemporaryDrawer = (props) => {
    const { data, filteredOptions, menuData } = props
    const classes = useStyles()
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    })
    const toggleDrawer = (side, open) => (event) => {
        if (
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return
        }
        setState({ ...state, [side]: open })
    }
    const FullList = (props) => {
        const [anchorEl, setAnchorEl] = React.useState({})
        const [openDropDown, setOpenDropDown] = React.useState()
        const { options, menuData, classes } = props
        const roots = findRoots(menuData, options)
        const handleClick = (id, item) => (event) => {
            event.persist()
            if (id === openDropDown) {
                setOpenDropDown('')
            } else {
                setOpenDropDown(id)
            }
            if (!anchorEl[id]) {
                event.stopPropagation()
            }
            event.preventDefault()
            setAnchorEl((existing) => ({
                ...existing,
                [id]: event.currentTarget,
            }))
        }
        const handleClose = (id) => () => {
            setAnchorEl(() => ({
                [id]: null,
            }))
        }
        const recursiveMapper =
            (arr, level = 0) =>
            (item, index) => {
                const childrenOfItem = findMyChildren(arr, item.node.id)
                const menuId = `menu-${level}-${item.node.menuText}`

                if (childrenOfItem.length > 0) {
                    if (level === 0) {
                        return (
                            <div>
                                <Divider />
                                <Accordion
                                    style={{ boxShadow: 'none' }}
                                    disableGutters={true}
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls="panel2d-content"
                                        id="panel1d-header"
                                    >
                                        <Typography
                                            style={{
                                                fontWeight: 600,
                                            }}
                                            className={classes.listItemText}
                                        >
                                            {item.node.menuText}
                                        </Typography>
                                    </AccordionSummary>

                                    <AccordionDetails>
                                        <div
                                            id={menuId}
                                            style={{ width: '100%' }}
                                        >
                                            {childrenOfItem.map(
                                                recursiveMapper(arr, level)
                                            )}
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        )
                    }
                    return (
                        <Menu
                            id={menuId}
                            key={item.node.id}
                            anchorEl={anchorEl[menuId]}
                            keepMounted
                            open={Boolean(anchorEl[menuId])}
                            onClose={handleClose(menuId)}
                            TransitionComponent={Fade}
                        >
                            {childrenOfItem.map(
                                recursiveMapper(arr, level + 1)
                            )}
                        </Menu>
                    )
                }

                //in case there is no dropdown
                if (level === 0) {
                    return (
                        <div className={classes.fullList} role="presentation">
                            <Divider />
                            <List disablePadding className={classes.appBar}>
                                <Link
                                    className={classes.link}
                                    to={link(
                                        menuId,
                                        item.node.name,
                                        item.node.pathPrefix
                                    )}
                                >
                                    <ListItem
                                        style={{ minHeight: '64px' }}
                                        className={classes.listItem}
                                    >
                                        <ListItemText align="left">
                                            <Grid container alignItems="center">
                                                <Grid item>
                                                    <Typography
                                                        style={{
                                                            fontWeight: 600,
                                                        }}
                                                        className={
                                                            classes.listItemText
                                                        }
                                                    >
                                                        {item.node.menuText}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </ListItemText>
                                    </ListItem>
                                </Link>
                            </List>
                        </div>
                    )
                }
                return (
                    <List className={classes.mobileDropdown}>
                        <Link
                            className={classes.link}
                            to={link(
                                menuId,
                                item.node.name,
                                item.node.pathPrefix
                            )}
                        >
                            <ListItem>
                                <ListItemText align="left">
                                    <Typography
                                        className={classes.listItemText}
                                    >
                                        {item.node.menuText}
                                    </Typography>
                                </ListItemText>
                            </ListItem>
                        </Link>
                    </List>
                )
            }

        const hasPhoneNumber = Boolean(data.phoneNumber)
        return (
            <React.Fragment>
                <Container maxWidth="lg">
                    <Grid
                        container
                        xs={12}
                        style={{ paddingTop: '20px', paddingBottom: '20px' }}
                    >
                        <Grid item xs={12}>
                            <CloseIcon
                                fontSize="medium"
                                style={{ margin: '10px 10px 30px 10px' }}
                                onClick={toggleDrawer('top', false)}
                            />
                        </Grid>
                        {hasPhoneNumber && (
                            <>
                                {' '}
                                <Grid
                                    icon
                                    xs={1}
                                    align="left"
                                    style={{
                                        paddingLeft: '13px',
                                        marginRight: '18px',
                                    }}
                                >
                                    <Icon style={{ fontSize: 0 }}>
                                        <StaticImage
                                            src="../../assets/Vector.svg"
                                            alt="phone"
                                        />
                                    </Icon>
                                </Grid>
                                <Grid item xs={10} align="left">
                                    <Typography
                                        variant="body2"
                                        style={{
                                            fontWeight: 600,
                                            color: 'rgba(15, 5, 24, 0.6)',
                                            marginLeft: '10px',
                                        }}
                                    >
                                        {data.phoneNumber}
                                    </Typography>
                                </Grid>
                            </>
                        )}
                    </Grid>

                    {roots.map(recursiveMapper(menuData))}
                </Container>
            </React.Fragment>
        )
    }
    return (
        <div>
            <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={toggleDrawer('top', true)}
            >
                <MenuIcon
                    fontSize="large"
                    style={{
                        backgroundColor: 'rgba(241, 87, 30, 0.1)',
                        color: '#F45F00',
                        borderRadius: '14px',
                        width: '40px',
                        height: '100%',
                        padding: '8px',
                    }}
                />
            </IconButton>
            <Drawer
                style={{ backgroundColor: '#ffffffb5' }}
                anchor="top"
                open={state.top}
                onClose={toggleDrawer('top', false)}
            >
                {/*FullList('top') - Only links No button*/}
                <FullList
                    options={filteredOptions}
                    menuData={menuData}
                    classes={classes}
                />
                {/*Apply Button Mobile*/}
                <ListItem
                    className={
                        data.button[0].buttonColor === 'Orange'
                            ? classes.listItemfff
                            : classes.listItem
                    }
                >
                    {/**/}
                    <ListItemText align="center" variant="body2">
                        {data && data.button && data.button.map((button) => {
                            const buttonColor = (color) => {
                                if (color === 'Orange') {
                                    return classes.buttonPrimary
                                }
                                return classes.buttonSecondary
                            }
                            const theButtonColor = buttonColor(
                                button.buttonColor
                            )
                            return (
                                <Grid item xs={12}>
                                    <SearchIcon
                                        fontSize="medium"
                                        style={{
                                            position: 'absolute',
                                            top: '16px',
                                            right: '121px',
                                        }}
                                        onClick={toggleDrawer('top', false)}
                                    />
                                    <ButtonSelector
                                        className={theButtonColor}
                                        data={button}
                                    >
                                        {button.label}
                                    </ButtonSelector>
                                </Grid>
                            )
                        })}
                    </ListItemText>
                </ListItem>
            </Drawer>
        </div>
    )
}
const dataOptions = {
    0: {
        available: true,
        contentful_id: '480jXQp2ZpVYOS0AunDTEE',
        id: '480jXQp2ZpVYOS0AunDTEE',
        menuText: 'University preparation',
        name: 'university-preparation',
        order: 2,
        title: 'University Preparation (Root menu)',
    },
    1: {
        available: true,
        contentful_id: '4tbQ50DrlyOpEqHTYWZO8V',
        id: '4tbQ50DrlyOpEqHTYWZO8V',
        menuText: 'Where to study',
        name: 'where-to-study',
        order: 3,
        title: 'Where to study (Root menu)',
    },
    2: {
        available: true,
        contentful_id: '2mxEinTMBYE4OtKlBgLp8u',
        id: '2mxEinTMBYE4OtKlBgLp8u',
        menuText: 'Get advice',
        name: 'blog',
        order: 4,
        title: 'Blog',
    },
    3: {
        available: true,
        contentful_id: '5LWO5JBWJI13L6RFPkiuHI',
        id: '5LWO5JBWJI13L6RFPkiuHI',
        menuText: 'Schools',
        name: 'schools',
        order: 6,
        title: 'schools',
    },
}
// const filteredOptions = data.options.filter(available);
// const filteredOptions = dataOptions;
const findRoots = (arr, options) => {
    // const availableIds = [dataOptions].map(option => option.index.id)
    const availableIds = Object.keys([dataOptions][0]).map(
        (option) => dataOptions[option].id
    )
    // console.log('availableIDs', availableIds)
    // console.log('Object.keys([dataOptions])', Object.keys([dataOptions]))
    // console.log('[dataOptions]', [dataOptions])
    const unsortedList = arr.filter(
        (item) =>
            item.node.parentPage === null &&
            item.node.available === true &&
            availableIds.includes(item.node.id)
    )
    return unsortedList.sort((a, b) => (a.node.order > b.node.order ? 1 : -1))
}
const findMyChildren = (arr, id) => {
    const unsortedList = arr.filter(
        (item) =>
            item.node.parentPage &&
            item.node.parentPage.id === id &&
            item.node.available === true
    )
    return unsortedList.sort((a, b) => (a.node.order > b.node.order ? 1 : -1))
}
//Dropdown check and Desktop
const MenuRenderer = (props) => {
    const [anchorEl, setAnchorEl] = React.useState({})
    const { options, menuData, classes } = props
    const roots = findRoots(menuData, options)
    const handleClick = (id) => (event) => {
        event.persist()
        if (!anchorEl[id]) {
            event.stopPropagation()
        }
        event.preventDefault()
        setAnchorEl((existing) => ({
            ...existing,
            [id]: event.currentTarget,
        }))
    }
    const handleClose = (id) => () => {
        setAnchorEl(() => ({
            [id]: null,
        }))
    }
    const navigateTo = (id, event, page, pathPrefix) => {
        event.preventDefault()
        setAnchorEl((existing) => ({
            ...existing,
            [id]: null,
        }))
        const handleIndex = (page) =>
            page === 'index'
                ? '/'
                : pathPrefix
                ? `/${pathPrefix}/${page}`
                : `/${page}`
        const finalUrl = handleIndex(page)
        navigate(finalUrl)
    }
    const recursiveMapper =
        (arr, level = 0) =>
        (item, index) => {
            const childrenOfItem = findMyChildren(arr, item.node.id)
            const menuId = `menu-${level}-${item.node.menuText}`
            if (childrenOfItem.length > 0) {
                if (level === 0) {
                    return (
                        <Grid
                            item
                            sm={3}
                            key={item.node.id}
                            className={classes.gridItem}
                        >
                            <Button
                                endIcon={<ArrowDropDownIcon />}
                                className={classes.link}
                                onClick={handleClick(menuId)}
                            >
                                {item.node.menuText}
                            </Button>
                            <Menu
                                style={{ marginTop: '3rem', minWidth: '20rem' }}
                                id={menuId}
                                anchorEl={anchorEl[menuId]}
                                keepMounted
                                open={Boolean(anchorEl[menuId])}
                                onClose={handleClose(menuId)}
                                TransitionComponent={Fade}
                            >
                                {childrenOfItem.map(
                                    recursiveMapper(arr, level + 1)
                                )}
                            </Menu>
                        </Grid>
                    )
                }
                return (
                    <Grid key={item.node.id}>
                        <Button
                            style={{
                                fontWeight: 'normal',
                                fontSize: '1.1875rem',
                                textAlign: 'left',
                                paddingLeft: '16px',
                            }}
                            endIcon={<ArrowRightIcon />}
                            className={classes.link}
                            onClick={handleClick(menuId)}
                        >
                            {item.node.menuText}
                        </Button>
                        <Menu
                            style={{ marginLeft: '15.5rem' }}
                            id={menuId}
                            key={item.node.id}
                            anchorEl={anchorEl[menuId]}
                            keepMounted
                            open={Boolean(anchorEl[menuId])}
                            onClose={handleClose(menuId)}
                            TransitionComponent={Fade}
                        >
                            {childrenOfItem.map(
                                recursiveMapper(arr, level + 1)
                            )}
                        </Menu>
                    </Grid>
                )
            }
            //in case there is no dropdown
            if (level === 0) {
                return (
                    <Grid
                        item
                        sm={2}
                        key={item.node.id}
                        className={classes.gridItem}
                    >
                        <Button
                            className={classes.link}
                            onClick={(event) =>
                                navigateTo(
                                    menuId,
                                    event,
                                    item.node.name,
                                    item.node.pathPrefix
                                )
                            }
                        >
                            {item.node.menuText}
                        </Button>
                    </Grid>
                )
            }
            return (
                <MenuItem
                    className={classes.link}
                    style={{
                        fontWeight: 'normal',
                        fontSize: '1.1875rem',
                        textAlign: 'left',
                    }}
                    key={item.node.id}
                    onClick={(event) =>
                        navigateTo(
                            menuId,
                            event,
                            item.node.name,
                            item.node.pathPrefix
                        )
                    }
                >
                    {item.node.menuText}
                </MenuItem>
            )
        }
    return (
        <React.Fragment>{roots.map(recursiveMapper(menuData))}</React.Fragment>
    )
}
const TopBar = (props) => {
    const graphqlData = useStaticQuery(graphql`
    query {
     
        contentfulComponentTopBarNavigation0: contentfulComponentTopBarNavigation (contentful_id: {eq: "1BnRPWcAL1Me5ffcwhDXX9"}) {
            id
            name
            logo {
              title
              gatsbyImageData(
                placeholder: DOMINANT_COLOR
                quality: 75
              )
            }
            button {
              label
              buttonColor
              linkTo
              pageexternalpdf {
                ... on ContentfulComponentExternalLink {
                  id
                  menuTitle
                  externalLink
                }
                ... on ContentfulPage {
                    id
                    name
                    menuText
                    pathPrefix
                  }
            }
              link
              anchorLink
              tagClass
            }
            phoneNumber
            contentful_id    
        }
    }
    `
)
const data = graphqlData["contentfulComponentTopBarNavigation0"]
const extraData = {
  "data": [
    {
      "node": {
        "sys": {
          "id": "7sLstJXeao55fMymbO7V7s"
        },
        "available": true,
        "name": "academic-tutorials",
        "menuText": "1:1 subject support",
        "order": 3,
        "title": "1:1 subject support",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "480jXQp2ZpVYOS0AunDTEE"
          },
          "available": true,
          "name": "university-preparation",
          "menuText": "University preparation",
          "order": 2,
          "title": "University Preparation (Root menu)",
          "pathPrefix": null,
          "contentful_id": "480jXQp2ZpVYOS0AunDTEE",
          "id": "480jXQp2ZpVYOS0AunDTEE",
          "parentPage": null
        },
        "contentful_id": "7sLstJXeao55fMymbO7V7s",
        "id": "7sLstJXeao55fMymbO7V7s"
      }
    },
    {
      "node": {
        "sys": {
          "id": "656XiQKsEq1wqc270Bi7DD"
        },
        "available": true,
        "name": "university-guidance",
        "menuText": "University guidance programs",
        "order": 1,
        "title": "University guidance!",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "7GzCWBkn7zE44ESpIsA2Un"
          },
          "available": true,
          "name": "uniguidance",
          "menuText": "University guidance",
          "order": 1,
          "title": "University guidance",
          "pathPrefix": null,
          "contentful_id": "7GzCWBkn7zE44ESpIsA2Un",
          "id": "7GzCWBkn7zE44ESpIsA2Un",
          "parentPage": null
        },
        "contentful_id": "656XiQKsEq1wqc270Bi7DD",
        "id": "656XiQKsEq1wqc270Bi7DD"
      }
    },
    {
      "node": {
        "sys": {
          "id": "31cmAwGY8QOBMT8RrL5fNE"
        },
        "parentPage": null,
        "available": true,
        "name": "terms",
        "menuText": "T&Cs",
        "order": null,
        "title": "Terms and Conditions",
        "pathPrefix": null,
        "contentful_id": "31cmAwGY8QOBMT8RrL5fNE",
        "id": "31cmAwGY8QOBMT8RrL5fNE"
      }
    },
    {
      "node": {
        "sys": {
          "id": "2OwqwVsqtq7th1xMJbXEVt"
        },
        "available": true,
        "name": "personal-statement-support",
        "menuText": "Personal statement support",
        "order": 4,
        "title": "Personal statement support",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "7GzCWBkn7zE44ESpIsA2Un"
          },
          "available": true,
          "name": "uniguidance",
          "menuText": "University guidance",
          "order": 1,
          "title": "University guidance",
          "pathPrefix": null,
          "contentful_id": "7GzCWBkn7zE44ESpIsA2Un",
          "id": "7GzCWBkn7zE44ESpIsA2Un",
          "parentPage": null
        },
        "contentful_id": "2OwqwVsqtq7th1xMJbXEVt",
        "id": "2OwqwVsqtq7th1xMJbXEVt"
      }
    },
    {
      "node": {
        "sys": {
          "id": "2OmoAgOio6uriFhHVQgySA"
        },
        "available": true,
        "name": "admissions-test-preparation",
        "menuText": "Admissions test preparation",
        "order": 5,
        "title": "Admissions test preparation",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "7GzCWBkn7zE44ESpIsA2Un"
          },
          "available": true,
          "name": "uniguidance",
          "menuText": "University guidance",
          "order": 1,
          "title": "University guidance",
          "pathPrefix": null,
          "contentful_id": "7GzCWBkn7zE44ESpIsA2Un",
          "id": "7GzCWBkn7zE44ESpIsA2Un",
          "parentPage": null
        },
        "contentful_id": "2OmoAgOio6uriFhHVQgySA",
        "id": "2OmoAgOio6uriFhHVQgySA"
      }
    },
    {
      "node": {
        "sys": {
          "id": "5Mw8aOvJfTH5S8HZdWbDJm"
        },
        "available": true,
        "name": "interview-preparation",
        "menuText": "Interview preparation",
        "order": 6,
        "title": "Interview preparation",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "7GzCWBkn7zE44ESpIsA2Un"
          },
          "available": true,
          "name": "uniguidance",
          "menuText": "University guidance",
          "order": 1,
          "title": "University guidance",
          "pathPrefix": null,
          "contentful_id": "7GzCWBkn7zE44ESpIsA2Un",
          "id": "7GzCWBkn7zE44ESpIsA2Un",
          "parentPage": null
        },
        "contentful_id": "5Mw8aOvJfTH5S8HZdWbDJm",
        "id": "5Mw8aOvJfTH5S8HZdWbDJm"
      }
    },
    {
      "node": {
        "sys": {
          "id": "42pogCWvorVmuS0easVTGH"
        },
        "available": true,
        "name": "university-study-skills",
        "menuText": "University study skills",
        "order": 7,
        "title": "University study skills",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "7GzCWBkn7zE44ESpIsA2Un"
          },
          "available": true,
          "name": "uniguidance",
          "menuText": "University guidance",
          "order": 1,
          "title": "University guidance",
          "pathPrefix": null,
          "contentful_id": "7GzCWBkn7zE44ESpIsA2Un",
          "id": "7GzCWBkn7zE44ESpIsA2Un",
          "parentPage": null
        },
        "contentful_id": "42pogCWvorVmuS0easVTGH",
        "id": "42pogCWvorVmuS0easVTGH"
      }
    },
    {
      "node": {
        "sys": {
          "id": "4bcISIYuG8SJbPZp5W9Mdq"
        },
        "available": true,
        "name": "undecided",
        "menuText": "Helping you to choose",
        "order": 3,
        "title": "undecided",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "7GzCWBkn7zE44ESpIsA2Un"
          },
          "available": true,
          "name": "uniguidance",
          "menuText": "University guidance",
          "order": 1,
          "title": "University guidance",
          "pathPrefix": null,
          "contentful_id": "7GzCWBkn7zE44ESpIsA2Un",
          "id": "7GzCWBkn7zE44ESpIsA2Un",
          "parentPage": null
        },
        "contentful_id": "4bcISIYuG8SJbPZp5W9Mdq",
        "id": "4bcISIYuG8SJbPZp5W9Mdq"
      }
    },
    {
      "node": {
        "sys": {
          "id": "6J0B3cSmFMTYlvNYDjnCif"
        },
        "available": true,
        "name": "pricing",
        "menuText": "Pricing",
        "order": 5,
        "title": "Pricing",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "480jXQp2ZpVYOS0AunDTEE"
          },
          "available": true,
          "name": "university-preparation",
          "menuText": "University preparation",
          "order": 2,
          "title": "University Preparation (Root menu)",
          "pathPrefix": null,
          "contentful_id": "480jXQp2ZpVYOS0AunDTEE",
          "id": "480jXQp2ZpVYOS0AunDTEE",
          "parentPage": null
        },
        "contentful_id": "6J0B3cSmFMTYlvNYDjnCif",
        "id": "6J0B3cSmFMTYlvNYDjnCif"
      }
    },
    {
      "node": {
        "sys": {
          "id": "6cQyMr3QFtPXCPb7DpQEDx"
        },
        "available": true,
        "name": "how-melio-works",
        "menuText": "How Melio works",
        "order": 8,
        "title": "How Melio works",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "7GzCWBkn7zE44ESpIsA2Un"
          },
          "available": true,
          "name": "uniguidance",
          "menuText": "University guidance",
          "order": 1,
          "title": "University guidance",
          "pathPrefix": null,
          "contentful_id": "7GzCWBkn7zE44ESpIsA2Un",
          "id": "7GzCWBkn7zE44ESpIsA2Un",
          "parentPage": null
        },
        "contentful_id": "6cQyMr3QFtPXCPb7DpQEDx",
        "id": "6cQyMr3QFtPXCPb7DpQEDx"
      }
    },
    {
      "node": {
        "sys": {
          "id": "5MaldIKFh97uJRZqLww3pp"
        },
        "available": true,
        "name": "study-in-the-uk",
        "menuText": "Study in the UK ",
        "order": 1,
        "title": "Study in the UK ",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "4tbQ50DrlyOpEqHTYWZO8V"
          },
          "available": true,
          "name": "where-to-study",
          "menuText": "Where to study",
          "order": 3,
          "title": "Where to study (Root menu)",
          "pathPrefix": null,
          "contentful_id": "4tbQ50DrlyOpEqHTYWZO8V",
          "id": "4tbQ50DrlyOpEqHTYWZO8V",
          "parentPage": null
        },
        "contentful_id": "5MaldIKFh97uJRZqLww3pp",
        "id": "5MaldIKFh97uJRZqLww3pp"
      }
    },
    {
      "node": {
        "sys": {
          "id": "3QeUfxW7xd8hFiLlMGcQ1n"
        },
        "parentPage": null,
        "available": true,
        "name": "university-guidance-for-schools-pdf",
        "menuText": "University guidance for schools brochure",
        "order": null,
        "title": "University pdf for schools ",
        "pathPrefix": null,
        "contentful_id": "3QeUfxW7xd8hFiLlMGcQ1n",
        "id": "3QeUfxW7xd8hFiLlMGcQ1n"
      }
    },
    {
      "node": {
        "sys": {
          "id": "2XUldSCLrZ1Oa2DasDHMUt"
        },
        "parentPage": null,
        "available": true,
        "name": "university-guidance-pdf",
        "menuText": "University guidance brochure",
        "order": null,
        "title": "University pdf",
        "pathPrefix": null,
        "contentful_id": "2XUldSCLrZ1Oa2DasDHMUt",
        "id": "2XUldSCLrZ1Oa2DasDHMUt"
      }
    },
    {
      "node": {
        "sys": {
          "id": "blPYmnQ9O4RU9xKbWaEwL"
        },
        "parentPage": null,
        "available": true,
        "name": "test",
        "menuText": "test",
        "order": null,
        "title": "Test(DO NOT DELETE)",
        "pathPrefix": null,
        "contentful_id": "blPYmnQ9O4RU9xKbWaEwL",
        "id": "blPYmnQ9O4RU9xKbWaEwL"
      }
    },
    {
      "node": {
        "sys": {
          "id": "53FduIG6L8slARkfgOSYMF"
        },
        "available": true,
        "name": "premium-university-guidance",
        "menuText": "Premium guidance programs",
        "order": 2,
        "title": "Premium university guidance",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "7GzCWBkn7zE44ESpIsA2Un"
          },
          "available": true,
          "name": "uniguidance",
          "menuText": "University guidance",
          "order": 1,
          "title": "University guidance",
          "pathPrefix": null,
          "contentful_id": "7GzCWBkn7zE44ESpIsA2Un",
          "id": "7GzCWBkn7zE44ESpIsA2Un",
          "parentPage": null
        },
        "contentful_id": "53FduIG6L8slARkfgOSYMF",
        "id": "53FduIG6L8slARkfgOSYMF"
      }
    },
    {
      "node": {
        "sys": {
          "id": "4uAgLmTjZ3G65y2VgN6ATB"
        },
        "available": true,
        "name": "about-us",
        "menuText": "About",
        "order": 1,
        "title": "About Us",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "3pk6v4cfcMxChmlAmqsRvr"
          },
          "available": true,
          "name": "about",
          "menuText": "About",
          "order": 5,
          "title": "About Melio",
          "pathPrefix": null,
          "contentful_id": "3pk6v4cfcMxChmlAmqsRvr",
          "id": "3pk6v4cfcMxChmlAmqsRvr",
          "parentPage": null
        },
        "contentful_id": "4uAgLmTjZ3G65y2VgN6ATB",
        "id": "4uAgLmTjZ3G65y2VgN6ATB"
      }
    },
    {
      "node": {
        "sys": {
          "id": "3PunlTsT2l07jGVj4Z4Tky"
        },
        "parentPage": null,
        "available": true,
        "name": "index",
        "menuText": "Home",
        "order": 1,
        "title": "Melio Education - Online Learning with Oxford and Cambridge tutors",
        "pathPrefix": null,
        "contentful_id": "3PunlTsT2l07jGVj4Z4Tky",
        "id": "3PunlTsT2l07jGVj4Z4Tky"
      }
    },
    {
      "node": {
        "sys": {
          "id": "1bYTwntNRfcMiWJbaZPl5C"
        },
        "parentPage": null,
        "available": true,
        "name": "new-features",
        "menuText": "Find out about our new features",
        "order": null,
        "title": "Find out about our new features",
        "pathPrefix": null,
        "contentful_id": "1bYTwntNRfcMiWJbaZPl5C",
        "id": "1bYTwntNRfcMiWJbaZPl5C"
      }
    },
    {
      "node": {
        "sys": {
          "id": "6gMsorqHCVlifFK46dhpf3"
        },
        "parentPage": null,
        "available": true,
        "name": "universityguidance-apply",
        "menuText": "University Guidance Sign Up",
        "order": null,
        "title": "University Guidance Sign Up",
        "pathPrefix": null,
        "contentful_id": "6gMsorqHCVlifFK46dhpf3",
        "id": "6gMsorqHCVlifFK46dhpf3"
      }
    },
    {
      "node": {
        "sys": {
          "id": "5fs4mm8hsNvOBTfj7L4OaP"
        },
        "available": true,
        "name": "business-and-entrepreneurship-aoc",
        "menuText": "Business and Entrepreneurship",
        "order": 2,
        "title": "Business and Entrepreneurship AOC ",
        "pathPrefix": "aoc",
        "parentPage": {
          "sys": {
            "id": "6p8LoO6tYJteeP36si4Y7u"
          },
          "available": true,
          "name": "acoc",
          "menuText": "Subject taster courses",
          "order": 2,
          "title": "Academic support placeholder",
          "pathPrefix": null,
          "contentful_id": "6p8LoO6tYJteeP36si4Y7u",
          "id": "6p8LoO6tYJteeP36si4Y7u",
          "parentPage": null
        },
        "contentful_id": "5fs4mm8hsNvOBTfj7L4OaP",
        "id": "5fs4mm8hsNvOBTfj7L4OaP"
      }
    },
    {
      "node": {
        "sys": {
          "id": "7GzCWBkn7zE44ESpIsA2Un"
        },
        "available": true,
        "name": "uniguidance",
        "menuText": "University guidance",
        "order": 1,
        "title": "University guidance",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "480jXQp2ZpVYOS0AunDTEE"
          },
          "available": true,
          "name": "university-preparation",
          "menuText": "University preparation",
          "order": 2,
          "title": "University Preparation (Root menu)",
          "pathPrefix": null,
          "contentful_id": "480jXQp2ZpVYOS0AunDTEE",
          "id": "480jXQp2ZpVYOS0AunDTEE",
          "parentPage": null
        },
        "contentful_id": "7GzCWBkn7zE44ESpIsA2Un",
        "id": "7GzCWBkn7zE44ESpIsA2Un"
      }
    },
    {
      "node": {
        "sys": {
          "id": "3IyjRL40jYPZL6zuZymIrs"
        },
        "available": true,
        "name": "biotechnology-and-genetics-aoc",
        "menuText": "Biotechnology and Genetics",
        "order": 1,
        "title": "Biotechnology and Genetics AOC ",
        "pathPrefix": "aoc",
        "parentPage": {
          "sys": {
            "id": "6p8LoO6tYJteeP36si4Y7u"
          },
          "available": true,
          "name": "acoc",
          "menuText": "Subject taster courses",
          "order": 2,
          "title": "Academic support placeholder",
          "pathPrefix": null,
          "contentful_id": "6p8LoO6tYJteeP36si4Y7u",
          "id": "6p8LoO6tYJteeP36si4Y7u",
          "parentPage": null
        },
        "contentful_id": "3IyjRL40jYPZL6zuZymIrs",
        "id": "3IyjRL40jYPZL6zuZymIrs"
      }
    },
    {
      "node": {
        "sys": {
          "id": "LQ8trl4Ei1fRas8l6DvLD"
        },
        "available": true,
        "name": "computer-science-aoc",
        "menuText": "Computer Science",
        "order": 3,
        "title": "Computer Science AOC ",
        "pathPrefix": "aoc",
        "parentPage": {
          "sys": {
            "id": "6p8LoO6tYJteeP36si4Y7u"
          },
          "available": true,
          "name": "acoc",
          "menuText": "Subject taster courses",
          "order": 2,
          "title": "Academic support placeholder",
          "pathPrefix": null,
          "contentful_id": "6p8LoO6tYJteeP36si4Y7u",
          "id": "6p8LoO6tYJteeP36si4Y7u",
          "parentPage": null
        },
        "contentful_id": "LQ8trl4Ei1fRas8l6DvLD",
        "id": "LQ8trl4Ei1fRas8l6DvLD"
      }
    },
    {
      "node": {
        "sys": {
          "id": "60R5cDCT6fr1oKqhPmnC24"
        },
        "available": true,
        "name": "economics-aoc",
        "menuText": "Economics",
        "order": 4,
        "title": "Economics AOC ",
        "pathPrefix": "aoc",
        "parentPage": {
          "sys": {
            "id": "6p8LoO6tYJteeP36si4Y7u"
          },
          "available": true,
          "name": "acoc",
          "menuText": "Subject taster courses",
          "order": 2,
          "title": "Academic support placeholder",
          "pathPrefix": null,
          "contentful_id": "6p8LoO6tYJteeP36si4Y7u",
          "id": "6p8LoO6tYJteeP36si4Y7u",
          "parentPage": null
        },
        "contentful_id": "60R5cDCT6fr1oKqhPmnC24",
        "id": "60R5cDCT6fr1oKqhPmnC24"
      }
    },
    {
      "node": {
        "sys": {
          "id": "121D0HJpbzBCTyZ0JqdqL6"
        },
        "available": true,
        "name": "english-literature-and-creative-writing-aoc",
        "menuText": "English Literature and Creative Writing",
        "order": 5,
        "title": "English Literature and Creative Writing AOC ",
        "pathPrefix": "aoc",
        "parentPage": {
          "sys": {
            "id": "6p8LoO6tYJteeP36si4Y7u"
          },
          "available": true,
          "name": "acoc",
          "menuText": "Subject taster courses",
          "order": 2,
          "title": "Academic support placeholder",
          "pathPrefix": null,
          "contentful_id": "6p8LoO6tYJteeP36si4Y7u",
          "id": "6p8LoO6tYJteeP36si4Y7u",
          "parentPage": null
        },
        "contentful_id": "121D0HJpbzBCTyZ0JqdqL6",
        "id": "121D0HJpbzBCTyZ0JqdqL6"
      }
    },
    {
      "node": {
        "sys": {
          "id": "2Y72nFFkMEH7lkZzTw6WzP"
        },
        "available": true,
        "name": "international-relations-and-politics-aoc",
        "menuText": "International Relations and Politics",
        "order": 6,
        "title": "International Relations and Politics AOC ",
        "pathPrefix": "aoc",
        "parentPage": {
          "sys": {
            "id": "6p8LoO6tYJteeP36si4Y7u"
          },
          "available": true,
          "name": "acoc",
          "menuText": "Subject taster courses",
          "order": 2,
          "title": "Academic support placeholder",
          "pathPrefix": null,
          "contentful_id": "6p8LoO6tYJteeP36si4Y7u",
          "id": "6p8LoO6tYJteeP36si4Y7u",
          "parentPage": null
        },
        "contentful_id": "2Y72nFFkMEH7lkZzTw6WzP",
        "id": "2Y72nFFkMEH7lkZzTw6WzP"
      }
    },
    {
      "node": {
        "sys": {
          "id": "7hIuPpfzDBl1uc2SIFZge8"
        },
        "available": true,
        "name": "law-aoc",
        "menuText": "Law",
        "order": 7,
        "title": "Law AOC",
        "pathPrefix": "aoc",
        "parentPage": {
          "sys": {
            "id": "6p8LoO6tYJteeP36si4Y7u"
          },
          "available": true,
          "name": "acoc",
          "menuText": "Subject taster courses",
          "order": 2,
          "title": "Academic support placeholder",
          "pathPrefix": null,
          "contentful_id": "6p8LoO6tYJteeP36si4Y7u",
          "id": "6p8LoO6tYJteeP36si4Y7u",
          "parentPage": null
        },
        "contentful_id": "7hIuPpfzDBl1uc2SIFZge8",
        "id": "7hIuPpfzDBl1uc2SIFZge8"
      }
    },
    {
      "node": {
        "sys": {
          "id": "3GMJUeOuBy88nO7Ysxr0hS"
        },
        "available": true,
        "name": "mathematics-aoc",
        "menuText": "Mathematics",
        "order": 8,
        "title": "Mathematics AOC ",
        "pathPrefix": "aoc",
        "parentPage": {
          "sys": {
            "id": "6p8LoO6tYJteeP36si4Y7u"
          },
          "available": true,
          "name": "acoc",
          "menuText": "Subject taster courses",
          "order": 2,
          "title": "Academic support placeholder",
          "pathPrefix": null,
          "contentful_id": "6p8LoO6tYJteeP36si4Y7u",
          "id": "6p8LoO6tYJteeP36si4Y7u",
          "parentPage": null
        },
        "contentful_id": "3GMJUeOuBy88nO7Ysxr0hS",
        "id": "3GMJUeOuBy88nO7Ysxr0hS"
      }
    },
    {
      "node": {
        "sys": {
          "id": "SP8iGpGZnjeqmk2zE4piq"
        },
        "available": true,
        "name": "medicine-aoc",
        "menuText": "Medicine",
        "order": 9,
        "title": "Medicine AOC ",
        "pathPrefix": "aoc",
        "parentPage": {
          "sys": {
            "id": "6p8LoO6tYJteeP36si4Y7u"
          },
          "available": true,
          "name": "acoc",
          "menuText": "Subject taster courses",
          "order": 2,
          "title": "Academic support placeholder",
          "pathPrefix": null,
          "contentful_id": "6p8LoO6tYJteeP36si4Y7u",
          "id": "6p8LoO6tYJteeP36si4Y7u",
          "parentPage": null
        },
        "contentful_id": "SP8iGpGZnjeqmk2zE4piq",
        "id": "SP8iGpGZnjeqmk2zE4piq"
      }
    },
    {
      "node": {
        "sys": {
          "id": "29BJf45i8sjcx8Q6ZEo19a"
        },
        "available": true,
        "name": "physics-aoc",
        "menuText": "Physics",
        "order": 10,
        "title": "Physics AOC ",
        "pathPrefix": "aoc",
        "parentPage": {
          "sys": {
            "id": "6p8LoO6tYJteeP36si4Y7u"
          },
          "available": true,
          "name": "acoc",
          "menuText": "Subject taster courses",
          "order": 2,
          "title": "Academic support placeholder",
          "pathPrefix": null,
          "contentful_id": "6p8LoO6tYJteeP36si4Y7u",
          "id": "6p8LoO6tYJteeP36si4Y7u",
          "parentPage": null
        },
        "contentful_id": "29BJf45i8sjcx8Q6ZEo19a",
        "id": "29BJf45i8sjcx8Q6ZEo19a"
      }
    },
    {
      "node": {
        "sys": {
          "id": "1Od9ALmU3NqTOVIf1kSPRs"
        },
        "available": true,
        "name": "psychology-aoc",
        "menuText": "Psychology",
        "order": 11,
        "title": "Psychology AOC",
        "pathPrefix": "aoc",
        "parentPage": {
          "sys": {
            "id": "6p8LoO6tYJteeP36si4Y7u"
          },
          "available": true,
          "name": "acoc",
          "menuText": "Subject taster courses",
          "order": 2,
          "title": "Academic support placeholder",
          "pathPrefix": null,
          "contentful_id": "6p8LoO6tYJteeP36si4Y7u",
          "id": "6p8LoO6tYJteeP36si4Y7u",
          "parentPage": null
        },
        "contentful_id": "1Od9ALmU3NqTOVIf1kSPRs",
        "id": "1Od9ALmU3NqTOVIf1kSPRs"
      }
    },
    {
      "node": {
        "sys": {
          "id": "6UnBXhexPZOHk4rk4eYFWi"
        },
        "available": true,
        "name": "aoc",
        "menuText": "Academic support",
        "order": 1,
        "title": "Academic support",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "6p8LoO6tYJteeP36si4Y7u"
          },
          "available": true,
          "name": "acoc",
          "menuText": "Subject taster courses",
          "order": 2,
          "title": "Academic support placeholder",
          "pathPrefix": null,
          "contentful_id": "6p8LoO6tYJteeP36si4Y7u",
          "id": "6p8LoO6tYJteeP36si4Y7u",
          "parentPage": null
        },
        "contentful_id": "6UnBXhexPZOHk4rk4eYFWi",
        "id": "6UnBXhexPZOHk4rk4eYFWi"
      }
    },
    {
      "node": {
        "sys": {
          "id": "1JIPJNJbFUGPqe6Bv8sjfe"
        },
        "available": true,
        "name": "career-guidance",
        "menuText": "Career guidance",
        "order": 4,
        "title": "Career guidance ",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "480jXQp2ZpVYOS0AunDTEE"
          },
          "available": true,
          "name": "university-preparation",
          "menuText": "University preparation",
          "order": 2,
          "title": "University Preparation (Root menu)",
          "pathPrefix": null,
          "contentful_id": "480jXQp2ZpVYOS0AunDTEE",
          "id": "480jXQp2ZpVYOS0AunDTEE",
          "parentPage": null
        },
        "contentful_id": "1JIPJNJbFUGPqe6Bv8sjfe",
        "id": "1JIPJNJbFUGPqe6Bv8sjfe"
      }
    },
    {
      "node": {
        "sys": {
          "id": "6p8LoO6tYJteeP36si4Y7u"
        },
        "available": true,
        "name": "acoc",
        "menuText": "Subject taster courses",
        "order": 2,
        "title": "Academic support placeholder",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "480jXQp2ZpVYOS0AunDTEE"
          },
          "available": true,
          "name": "university-preparation",
          "menuText": "University preparation",
          "order": 2,
          "title": "University Preparation (Root menu)",
          "pathPrefix": null,
          "contentful_id": "480jXQp2ZpVYOS0AunDTEE",
          "id": "480jXQp2ZpVYOS0AunDTEE",
          "parentPage": null
        },
        "contentful_id": "6p8LoO6tYJteeP36si4Y7u",
        "id": "6p8LoO6tYJteeP36si4Y7u"
      }
    },
    {
      "node": {
        "sys": {
          "id": "2eT7UDH7TgpSCjpTN1Mm2D"
        },
        "available": true,
        "name": "university-preparation-program",
        "menuText": "University Preparation Program",
        "order": 2,
        "title": "University Preparation Program",
        "pathPrefix": "courses",
        "parentPage": {
          "sys": {
            "id": "78C9rMCKFhQWMw4rV6pBvo"
          },
          "available": true,
          "name": "courses",
          "menuText": "Courses",
          "order": 3,
          "title": "Courses",
          "pathPrefix": null,
          "contentful_id": "78C9rMCKFhQWMw4rV6pBvo",
          "id": "78C9rMCKFhQWMw4rV6pBvo",
          "parentPage": null
        },
        "contentful_id": "2eT7UDH7TgpSCjpTN1Mm2D",
        "id": "2eT7UDH7TgpSCjpTN1Mm2D"
      }
    },
    {
      "node": {
        "sys": {
          "id": "5gpqPAPavLb7qtzUmO2S91"
        },
        "parentPage": null,
        "available": true,
        "name": "oxbridge-webinar-recording",
        "menuText": "Oxbridge Webinar Recording",
        "order": null,
        "title": "Oxbridge Webinar Recording",
        "pathPrefix": null,
        "contentful_id": "5gpqPAPavLb7qtzUmO2S91",
        "id": "5gpqPAPavLb7qtzUmO2S91"
      }
    },
    {
      "node": {
        "sys": {
          "id": "4NbtFi4GRftGGHu8OojmT9"
        },
        "available": true,
        "name": "programs-and-packages",
        "menuText": "Programs and packages",
        "order": 1,
        "title": "Programs and packages",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "5LWO5JBWJI13L6RFPkiuHI"
          },
          "available": true,
          "name": "schools",
          "menuText": "Melio for schools",
          "order": 4,
          "title": "melio for schools",
          "pathPrefix": null,
          "contentful_id": "5LWO5JBWJI13L6RFPkiuHI",
          "id": "5LWO5JBWJI13L6RFPkiuHI",
          "parentPage": null
        },
        "contentful_id": "4NbtFi4GRftGGHu8OojmT9",
        "id": "4NbtFi4GRftGGHu8OojmT9"
      }
    },
    {
      "node": {
        "sys": {
          "id": "5LWO5JBWJI13L6RFPkiuHI"
        },
        "parentPage": null,
        "available": true,
        "name": "schools",
        "menuText": "Melio for schools",
        "order": 4,
        "title": "melio for schools",
        "pathPrefix": null,
        "contentful_id": "5LWO5JBWJI13L6RFPkiuHI",
        "id": "5LWO5JBWJI13L6RFPkiuHI"
      }
    },
    {
      "node": {
        "sys": {
          "id": "6LHqKMMkS036uS7uD5dP6h"
        },
        "available": true,
        "name": "tutors",
        "menuText": "Tutors",
        "order": 2,
        "title": "Tutors All",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "3pk6v4cfcMxChmlAmqsRvr"
          },
          "available": true,
          "name": "about",
          "menuText": "About",
          "order": 5,
          "title": "About Melio",
          "pathPrefix": null,
          "contentful_id": "3pk6v4cfcMxChmlAmqsRvr",
          "id": "3pk6v4cfcMxChmlAmqsRvr",
          "parentPage": null
        },
        "contentful_id": "6LHqKMMkS036uS7uD5dP6h",
        "id": "6LHqKMMkS036uS7uD5dP6h"
      }
    },
    {
      "node": {
        "sys": {
          "id": "2mxEinTMBYE4OtKlBgLp8u"
        },
        "parentPage": null,
        "available": true,
        "name": "blog",
        "menuText": "Get advice",
        "order": 5,
        "title": "Blog",
        "pathPrefix": null,
        "contentful_id": "2mxEinTMBYE4OtKlBgLp8u",
        "id": "2mxEinTMBYE4OtKlBgLp8u"
      }
    },
    {
      "node": {
        "sys": {
          "id": "5TWoDi16jOOi6YVDERecDS"
        },
        "parentPage": null,
        "available": true,
        "name": "help",
        "menuText": "Help",
        "order": null,
        "title": "Help",
        "pathPrefix": null,
        "contentful_id": "5TWoDi16jOOi6YVDERecDS",
        "id": "5TWoDi16jOOi6YVDERecDS"
      }
    },
    {
      "node": {
        "sys": {
          "id": "7svCBA75Me7LwdXjCsKMJC"
        },
        "available": true,
        "name": "how-it-works",
        "menuText": "How it works",
        "order": 2,
        "title": "How it works",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "5LWO5JBWJI13L6RFPkiuHI"
          },
          "available": true,
          "name": "schools",
          "menuText": "Melio for schools",
          "order": 4,
          "title": "melio for schools",
          "pathPrefix": null,
          "contentful_id": "5LWO5JBWJI13L6RFPkiuHI",
          "id": "5LWO5JBWJI13L6RFPkiuHI",
          "parentPage": null
        },
        "contentful_id": "7svCBA75Me7LwdXjCsKMJC",
        "id": "7svCBA75Me7LwdXjCsKMJC"
      }
    },
    {
      "node": {
        "sys": {
          "id": "3pk6v4cfcMxChmlAmqsRvr"
        },
        "parentPage": null,
        "available": true,
        "name": "about",
        "menuText": "About",
        "order": 5,
        "title": "About Melio",
        "pathPrefix": null,
        "contentful_id": "3pk6v4cfcMxChmlAmqsRvr",
        "id": "3pk6v4cfcMxChmlAmqsRvr"
      }
    },
    {
      "node": {
        "sys": {
          "id": "4tbQ50DrlyOpEqHTYWZO8V"
        },
        "parentPage": null,
        "available": true,
        "name": "where-to-study",
        "menuText": "Where to study",
        "order": 3,
        "title": "Where to study (Root menu)",
        "pathPrefix": null,
        "contentful_id": "4tbQ50DrlyOpEqHTYWZO8V",
        "id": "4tbQ50DrlyOpEqHTYWZO8V"
      }
    },
    {
      "node": {
        "sys": {
          "id": "480jXQp2ZpVYOS0AunDTEE"
        },
        "parentPage": null,
        "available": true,
        "name": "university-preparation",
        "menuText": "University preparation",
        "order": 2,
        "title": "University Preparation (Root menu)",
        "pathPrefix": null,
        "contentful_id": "480jXQp2ZpVYOS0AunDTEE",
        "id": "480jXQp2ZpVYOS0AunDTEE"
      }
    },
    {
      "node": {
        "sys": {
          "id": "1l91xSgOT3zh0ef7QMDoN2"
        },
        "parentPage": null,
        "available": true,
        "name": "careers",
        "menuText": "Careers",
        "order": null,
        "title": "Careers",
        "pathPrefix": null,
        "contentful_id": "1l91xSgOT3zh0ef7QMDoN2",
        "id": "1l91xSgOT3zh0ef7QMDoN2"
      }
    },
    {
      "node": {
        "sys": {
          "id": "78C9rMCKFhQWMw4rV6pBvo"
        },
        "parentPage": null,
        "available": true,
        "name": "courses",
        "menuText": "Courses",
        "order": 3,
        "title": "Courses",
        "pathPrefix": null,
        "contentful_id": "78C9rMCKFhQWMw4rV6pBvo",
        "id": "78C9rMCKFhQWMw4rV6pBvo"
      }
    },
    {
      "node": {
        "sys": {
          "id": "6k6O6XhbuonvPxl35k3uiT"
        },
        "parentPage": null,
        "available": true,
        "name": "upcoming-course-dates",
        "menuText": "Course dates",
        "order": null,
        "title": "Upcoming course dates",
        "pathPrefix": null,
        "contentful_id": "6k6O6XhbuonvPxl35k3uiT",
        "id": "6k6O6XhbuonvPxl35k3uiT"
      }
    },
    {
      "node": {
        "sys": {
          "id": "2AsqrghAsRkNyOn7AVwHkg"
        },
        "parentPage": null,
        "available": true,
        "name": "webinar-signup",
        "menuText": "Webinar sign up",
        "order": null,
        "title": "Webinar sign up",
        "pathPrefix": null,
        "contentful_id": "2AsqrghAsRkNyOn7AVwHkg",
        "id": "2AsqrghAsRkNyOn7AVwHkg"
      }
    },
    {
      "node": {
        "sys": {
          "id": "42WeGCNViWuGhqzEOmZEU6"
        },
        "parentPage": null,
        "available": true,
        "name": "quiz",
        "menuText": "Quiz",
        "order": null,
        "title": "Quiz page ",
        "pathPrefix": null,
        "contentful_id": "42WeGCNViWuGhqzEOmZEU6",
        "id": "42WeGCNViWuGhqzEOmZEU6"
      }
    },
    {
      "node": {
        "sys": {
          "id": "5JT4cwRTcrlMUr8iOlxzAi"
        },
        "parentPage": null,
        "available": true,
        "name": "university-webinars",
        "menuText": "University Webinars",
        "order": null,
        "title": "University Webinars",
        "pathPrefix": null,
        "contentful_id": "5JT4cwRTcrlMUr8iOlxzAi",
        "id": "5JT4cwRTcrlMUr8iOlxzAi"
      }
    },
    {
      "node": {
        "sys": {
          "id": "1tFMCgpiyN85GIVX5iYVdb"
        },
        "available": true,
        "name": "academic-online-courses",
        "menuText": "Academic Online Courses",
        "order": 1,
        "title": "AOC",
        "pathPrefix": null,
        "parentPage": {
          "sys": {
            "id": "78C9rMCKFhQWMw4rV6pBvo"
          },
          "available": true,
          "name": "courses",
          "menuText": "Courses",
          "order": 3,
          "title": "Courses",
          "pathPrefix": null,
          "contentful_id": "78C9rMCKFhQWMw4rV6pBvo",
          "id": "78C9rMCKFhQWMw4rV6pBvo",
          "parentPage": null
        },
        "contentful_id": "1tFMCgpiyN85GIVX5iYVdb",
        "id": "1tFMCgpiyN85GIVX5iYVdb"
      }
    },
    {
      "node": {
        "sys": {
          "id": "3THmzTCsd7R2XEG6Fpi6fl"
        },
        "parentPage": null,
        "available": true,
        "name": "bcourses",
        "menuText": "Courses",
        "order": null,
        "title": "Bethan Courses 2",
        "pathPrefix": null,
        "contentful_id": "3THmzTCsd7R2XEG6Fpi6fl",
        "id": "3THmzTCsd7R2XEG6Fpi6fl"
      }
    },
    {
      "node": {
        "sys": {
          "id": "V0cifPQfZAQFySjZN3Pbt"
        },
        "parentPage": null,
        "available": true,
        "name": "reviews",
        "menuText": "Reviews",
        "order": 5,
        "title": "Reviews",
        "pathPrefix": null,
        "contentful_id": "V0cifPQfZAQFySjZN3Pbt",
        "id": "V0cifPQfZAQFySjZN3Pbt"
      }
    },
    {
      "node": {
        "sys": {
          "id": "5Hn0bsdCxu71aSxCokvM3t"
        },
        "parentPage": null,
        "available": true,
        "name": "faq",
        "menuText": "FAQs",
        "order": null,
        "title": "Frequently Asked Questions",
        "pathPrefix": null,
        "contentful_id": "5Hn0bsdCxu71aSxCokvM3t",
        "id": "5Hn0bsdCxu71aSxCokvM3t"
      }
    }
  ]
};
const menuData = extraData.data
    const classes = useStyles()
    // const available = option => option.available;
    const dataOptions = {
        0: {
            available: true,
            contentful_id: '480jXQp2ZpVYOS0AunDTEE',
            id: '480jXQp2ZpVYOS0AunDTEE',
            menuText: 'University preparation',
            name: 'university-preparation',
            order: 2,
            title: 'University Preparation (Root menu)',
        },
        1: {
            available: true,
            contentful_id: '4tbQ50DrlyOpEqHTYWZO8V',
            id: '4tbQ50DrlyOpEqHTYWZO8V',
            menuText: 'Where to study',
            name: 'where-to-study',
            order: 3,
            title: 'Where to study (Root menu)',
        },
        2: {
            available: true,
            contentful_id: '2mxEinTMBYE4OtKlBgLp8u',
            id: '2mxEinTMBYE4OtKlBgLp8u',
            menuText: 'Get advice',
            name: 'blog',
            order: 4,
            title: 'Blog',
        },
        3: {
            available: true,
            contentful_id: '5LWO5JBWJI13L6RFPkiuHI',
            id: '5LWO5JBWJI13L6RFPkiuHI',
            menuText: 'Schools',
            name: 'schools',
            order: 6,
            title: 'schools',
        },
    }
    // const filteredOptions = data.options.filter(available);
    const filteredOptions = dataOptions
    const images = getImage(data.logo)
    return (
        <AppBar className={classes.appBar}>
            <Container maxWidth="lg">
                <Toolbar disableGutters>
                    <Grid container lg={12}>
                        <Grid                             
                        item
                        xs={6}
                        sm={3}
                        style={{ paddingRight: '10px' }}>
                            <Box pt={0.5}>
                                <Link to="/">
                                    <GatsbyImage
                                        className={classes.image}
                                        image={images}
                                        alt={data.logo.title}
                                    />
                                </Link>
                            </Box>
                        </Grid>
                        <Hidden smDown>
                            <Grid container item sm={8}>
                                <MenuRenderer
                                    options={filteredOptions}
                                    menuData={menuData}
                                    classes={classes}
                                />
                            </Grid>
                            <Grid
                                container
                                item
                                sm={1}
                                className={classes.buttonContainer}
                            >
                                {data && data.button && data.button.map((button) => {
                                    const buttonColor = (color) => {
                                        if (color === 'Orange') {
                                            return classes.buttonPrimary
                                        }
                                        return classes.buttonSecondary
                                    }
                                    const theButtonColor = buttonColor(
                                        button.buttonColor
                                    )
                                    return (
                                        <Grid item xs={12}>
                                            <ButtonSelector
                                                className={theButtonColor}
                                                data={button}
                                            >
                                                {button.label}
                                            </ButtonSelector>
                                        </Grid>
                                    )
                                })}
                            </Grid>
                        </Hidden>
                        <Hidden mdUp>
                            <Grid
                                item
                                xs={6}
                                sm={8}
                                className={classes.buttonContainer}
                            >
                                <Box pt={2}>
                                    <TemporaryDrawer
                                        {...props}
                                        menuData={menuData}
                                        data={data}
                                        filteredOptions={filteredOptions}
                                    />
                                </Box>
                            </Grid>
                        </Hidden>
                    </Grid>
                </Toolbar>
            </Container>
        </AppBar>
    )
}
export default TopBar
